import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { OS_NAV } from "./nav";

// ⌘K / Ctrl-K command palette — jump to any ArcaOS module.
export default function CommandPalette({ open, onClose }) {
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const items = OS_NAV.filter((n) => n.label.toLowerCase().includes(q.toLowerCase()));

  useEffect(() => { if (open) setQ(""); }, [open]);
  if (!open) return null;

  const go = (path) => { onClose(); navigate(path); };

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-32 bg-black/60 backdrop-blur-sm" onClick={onClose} data-testid="os-command-palette">
      <div className="w-full max-w-xl rounded-2xl border border-white/10 bg-[#0a0a0a] shadow-2xl overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <input
          autoFocus value={q} onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter" && items[0]) go(items[0].path); if (e.key === "Escape") onClose(); }}
          placeholder="Jump to… (type a module name)"
          className="w-full bg-transparent px-5 py-4 text-white outline-none border-b border-white/10"
          data-testid="os-command-input"
        />
        <div className="max-h-80 overflow-auto p-2">
          {items.map((n) => (
            <button key={n.key} onClick={() => go(n.path)} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left text-slate-200 hover:bg-white/5 transition-colors duration-150" data-testid={`os-cmd-${n.key}`}>
              <n.icon size={16} className="text-[#00F0FF]" />
              <span>{n.label}</span>
              {n.phase === 1 && <span className="ml-auto text-[10px] font-mono text-slate-600 uppercase">Phase 1</span>}
            </button>
          ))}
          {items.length === 0 && <p className="px-3 py-6 text-center text-slate-600 text-sm">No matches</p>}
        </div>
      </div>
    </div>
  );
}
